import { Flex, styled } from '@withjoy/joykit';
import { pxToRem } from '@shared/joykit/packages/core/common';

export const ContainerWrapper = styled(Flex)`
  margin-left: auto;
  margin-right: auto;
  gap: ${pxToRem(24)};
  margin-top: ${pxToRem(28)};
`;
export const CustomContainerWrapper = styled(Flex)`
  min-height: ${pxToRem(352)};
  border-radius: 12px;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  width: 100%;
  max-width: ${pxToRem(352)};
  flex-direction: column;
  cursor: pointer;
`;
export const Thumbnail = styled.img<{ height?: string }>`
  width: 100%;
  object-fit: cover;
  object-position: center;
  ${props => (props.height ? `height: ${props.height}` : '')};
`;

export const FeaturedPopularTourWrapper = styled(Flex)<{ isLast: boolean }>`
  padding-top: ${pxToRem(16)};
  padding-bottom: ${pxToRem(16)};
  gap: ${pxToRem(8)};
  border-bottom: ${props => (props.isLast ? 'none' : `1px solid ${props.theme.colors.mono3}`)};
  cursor: pointer;
`;

export const PhotoUploadPlaceholder = styled(Flex)`
  background-color: ${props => props.theme.colors.mono2};
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: ${pxToRem(234)};
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const ImagePreview = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;
